import { createBrowserRouter } from "react-router-dom";
import Login from "../pages/Login";
import ROUTES from ".";
import PrivateRoute from "./privateRoute";
import Home from "../pages/Home";
import ErrorPage from "../pages/ErrorPage";
import AdminLayout from "../components/layout/AdminLayout";
import NotificationPage from "../pages/Notification";
import Register from "../pages/Register";
import ForgotPassword from "../pages/ForgotPassword";
import LandingPage from "../pages/LandingPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsConditions from "../pages/TermsConditions";
import Contact from "../pages/Contact/Contact";
import AuthorizeGuard from "../components/AuthorizeGuard";
import { UserRole } from "../shared/constants";
import BillGateHome from "../pages/BillGate/Home";
import Company from "../pages/Company";
import Module from "../pages/Module";
import CompanyUser from "../pages/CompanyUser";
import Subscription from "../pages/Subscription";
import ChartOfAccount from "../pages/BillGate/Account";
import VoucherRegister from "../pages/BillGate/VoucherRegister";
import CreditVoucher from "../pages/BillGate/CreditVoucher";
import DebitVoucher from "../pages/BillGate/DebitVoucher";
import JournalVoucher from "../pages/BillGate/JournalVoucher";
import ServiceCenter from "../pages/SerialNo/ServiceCenter";
import ServiceType from "../pages/SerialNo/ServiceType";
import UserSettings from "../pages/Settings/UserSettings";
import MyProfile from "../pages/MyProfile/MyProfile";
import SerialNoSettings from "../pages/SerialNo/SerialNoSettings";
import MySerials from "../pages/Customer/MySerials";
import CompanyDetail from "../pages/Company/CompanyDetail";
import ServiceMan from "../pages/SerialNo/ServiceMan";
import OffDays from "../pages/SerialNo/OffDays";
import Location from "../pages/Location";

const router = createBrowserRouter([
  { path: ROUTES.PATHS.LANDING_PAGE, element: <LandingPage />, index: true },
  { path: ROUTES.PATHS.PRIVACY_POLICY_PUBLIC, element: <PrivacyPolicy /> },
  { path: ROUTES.PATHS.TERMS_CONDITIONS_PUBLIC, element: <TermsConditions /> },
  { path: ROUTES.PATHS.CONTACT, element: <Contact /> },
  { path: ROUTES.PATHS.LOGIN, element: <Login /> },
  { path: ROUTES.PATHS.REGISTER, element: <Register /> },
  { path: ROUTES.PATHS.FORGOT_PASSWORD, element: <ForgotPassword /> },
  {
    path: ROUTES.PATHS.BILLGATE_HOME,
    element: (
      <PrivateRoute>
        <AdminLayout />
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <BillGateHome />,
      },
      { path: ROUTES.PATHS.CHART_OF_ACCOUNTS, element: <AuthorizeGuard allowedRole={UserRole.Admin}><ChartOfAccount /></AuthorizeGuard> },
      { path: ROUTES.PATHS.VOUCHER_REGISTER, element: <AuthorizeGuard allowedRole={UserRole.Admin}> <VoucherRegister /> </AuthorizeGuard> },
      { path: ROUTES.PATHS.CREDIT_VOUCHER, element: <AuthorizeGuard allowedRole={UserRole.Admin}> <CreditVoucher /></AuthorizeGuard> },
      { path: ROUTES.PATHS.DEBIT_VOUCHER, element: <AuthorizeGuard allowedRole={UserRole.Admin}><DebitVoucher /></AuthorizeGuard> },
      { path: ROUTES.PATHS.JOURNAL_VOUCHER, element: <AuthorizeGuard allowedRole={UserRole.Admin}> <JournalVoucher /> </AuthorizeGuard> },
      // { path: ROUTES.PATHS.SETTINGS, element: <Settings /> },
      { path: ROUTES.PATHS.NOTIFICATIONS, element: <NotificationPage /> },
    ],
  },
  {
    path: ROUTES.PATHS.SL_HOME,
    element: <PrivateRoute><AdminLayout /></PrivateRoute>,
    children: [
      { index: true, element: <Home /> },
      { path: ROUTES.PATHS.PROFILE, element: <UserSettings /> },
      { path: `${ROUTES.PATHS.PROFILE}/:section`, element: <MyProfile /> },
      { path: ROUTES.PATHS.SERVICE_CENTERS, element: <ServiceCenter /> },
      { path: ROUTES.PATHS.SERVICE_TYPES, element: <ServiceType /> },
      { path: ROUTES.PATHS.SERVICE_MEN, element: <ServiceMan /> },
      { path: ROUTES.PATHS.OFF_DAYS, element: <OffDays /> },
      { path: ROUTES.PATHS.SERIALNO_SETTINGS, element: <SerialNoSettings /> },
      { path: ROUTES.PATHS.CUSTOMER_SERVICES, element: <MySerials /> },
      { path: ROUTES.PATHS.DEVELOPER_COMPANIES, element: <Company /> },
      { path: ROUTES.PATHS.DEVELOPER_LOCATIONS, element: <Location /> }
    ]
  },
  {
    path: ROUTES.PATHS.MODULES,
    element: <PrivateRoute><AdminLayout /></PrivateRoute>,
    children: [{ index: true, element: <Module /> }]
  },
  {
    path: ROUTES.PATHS.COMPANIES,
    element: <PrivateRoute><AdminLayout /></PrivateRoute>,
    children: [
      { index: true, element: <Company /> },
      { path: ROUTES.PATHS.COMPANY_DETAILS, element: <CompanyDetail /> },
      { path: ROUTES.PATHS.COMPANY_USERS, element: <CompanyUser presentation="User" /> }
    ]
  },
  {
    path: ROUTES.PATHS.SUBSCRIPTIONS,
    element: <PrivateRoute><AdminLayout /></PrivateRoute>,
    children: [{ index: true, element: <Subscription /> }]
  },
]);

export default router;
